import SideMenu from "./sideMenu";
import { useEffect, useMemo, useState } from "react";
import config from "../../config";
import { useSelector } from "react-redux";
import MaterialTable, { MTableToolbar } from "material-table";
import { tableIcons } from "../../tableIcons";
import { Button, Modal, Spinner } from "react-bootstrap";
import {
  Row,
  Col,
  DatePicker,
  Card,
  Button as AntdButton,
  Select,
  theme,
  Tag,
} from "antd";
import { Box, CircularProgress, TablePagination } from "@material-ui/core";
import { groupBy, values, sumBy } from "lodash";
import moment from "moment";
import { FiDownload } from "react-icons/fi";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import AnalyticsCard from "../analyticsCard";
import Icon from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomTable from "../table";
import dayjs from "dayjs";
import Loader from "../loader";
import {
  AverageSaleIcon,
  CreditIcon,
  NewCustomerIcon,
  RecurringCustomersIcon,
  SalesReturnIcon,
  TotalSalesIcon,
  UpiIcon,
} from "../../assets/reportPageIcon";
import { faCashRegister, faVcard } from "@fortawesome/free-solid-svg-icons";
import { BsCash, BsCreditCard } from "react-icons/bs";
import { FcDebt } from "react-icons/fc";
import { render } from "@testing-library/react";

const { RangePicker } = DatePicker;

const Reports = ({
  billList = [],
  setTotalSalesValue = () => {},
  isLoading = false,
  totalExpenses = 0,
  expensesList = [],
  ...props
}) => {
  const {
    token: { colorPrimary },
  } = theme.useToken();
  useEffect(() => {
    function keydownHandler(event) {
      event.stopImmediatePropagation();
      if (event.altKey && event.keyCode == 68) {
        // Download Report (D)
        getCustomerReport();
      } else if (event.altKey && event.keyCode == 83) {
        // Search (S)tableSearchSelect
        let input = document.querySelector(
          "#tableSearchSelect .MuiInputBase-input"
        );
        if (input) input.focus();
      } else if (event.altKey && event.keyCode == 69) {
        // Export (E)
        let input = document.querySelectorAll(".MuiIconButton-colorInherit");
        if (input[1]) {
          input[1].click();
          const exportBtn = document.querySelector(
            ".MuiButtonBase-root.MuiListItem-root.MuiMenuItem-root.MuiMenuItem-gutters.MuiListItem-gutters.MuiListItem-button"
          );
          exportBtn.click();
        }
      }
    }
    document.addEventListener("keydown", keydownHandler, false);
    return () => {
      window.removeEventListener("keydown", keydownHandler, false);
    };
  }, []);
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const billLineSettings = useSelector((state) => state.settings.settings);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const shopDetails = useSelector((state) => state.shopDetails);
  const currentData = moment();
  const [fromDate, setFromDate] = useState(currentData);
  const [toDate, setToDate] = useState(currentData);
  const [totalSale, setTotalSale] = useState(0);
  // const [bills, setBills] = useState([]);
  const [billData, setBillData] = useState();
  const [invoiceModal, setInvoiceModal] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [products, setProducts] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [category, setCategory] = useState("");
  const [categoryArray, setCategoryArray] = useState([]);
  const [recurringCustomers, setRecurringCustomers] = useState(0);
  const [newCustomer, setNewCustomer] = useState(0);
  const [totalSalesReturn, setTotalSalesReturn] = useState(0);
  const [csvLoader, setCsvLoader] = useState(false);
  const [taxList, setTaxList] = useState([]);
  const [taxLoader, setTaxLoader] = useState(true);
  const [reportsList, setReportsList] = useState([]);
  const [salesReportsList, setSalesReportsList] = useState([]);
  const [cancelledBillList, setCancelledBill] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [creditTotal, setCreditTotal] = useState("");
  const [upiTotal, setUpiTotal] = useState("");
  const [cardTotal, setCardTotal] = useState("");
  const [cashTotal, setCashTotal] = useState("");
  const [employeeArr, setEmployeeArr] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState();
  const [viewTrigger, setViewTrigger] = useState(true);
  const sortArray = (tempProd) => {
    return tempProd.sort((d1, d2) => {
      if (d1.count < d2.count) return 1;
      if (d1.count > d2.count) return -1;
      if (d1.count === d2.count) {
        if (d1.totalAmount < d2.totalAmount) return 1;
        if (d1.totalAmount > d2.totalAmount) return -1;
        return 0;
      }
    });
  };
  const cancelledBills = useMemo(() => {
    return billList.filter((bill) => bill.billCancelled);
  }, [billList]);
  useEffect(() => {
    fetchEmployee();
  }, [shopDetails.shopId]);

  const fetchEmployee = async () => {
    try {
      var res = await fetch(
        `${config.newApiGateway}/employe/createEmployee-fetchEmployee`,
        {
          method: "post",
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            action: "fetchEmployee",
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      res = await res.json();
      if (res.code === "SUCCESS") {
        setEmployeeArr(res.data);
      } else {
        // alert(res.message);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const newPaymentMethodData = () => {
    const obj = {};

    billList.forEach((i) => {
      const fullyReturned = i.items.every((i) => i.fullyReturned);
      console.log("fullyReturned", fullyReturned, i.billId);
      if (i.otherDetails?.paymentMethod && !fullyReturned) {
        if (Array.isArray(i.otherDetails.paymentMethod)) {
          if (i.otherDetails.paymentMethod.length == 1) {
            let pMethod = i.otherDetails.paymentMethod[0].method;
            let pAmount = i.otherDetails.paymentMethod[0].paidAmount;
            let exactPrice = 0;
            if (pMethod != "credit") {
              exactPrice =
                parseFloat(i.balanceAmount) <= 0
                  ? parseFloat(pAmount) + parseFloat(i.balanceAmount)
                  : parseFloat(pAmount);
              if (obj.hasOwnProperty(pMethod)) {
                obj[pMethod] = obj[pMethod] + parseFloat(exactPrice);
              } else {
                obj[pMethod] = exactPrice;
              }
            }
          } else {
            i.otherDetails.paymentMethod.forEach((j) => {
              if (j.method != "cash" && j.method != "credit") {
                if (obj.hasOwnProperty(j.method)) {
                  obj[j.method] = obj[j.method] + parseFloat(j.paidAmount);
                } else {
                  obj[j.method] = parseFloat(j.paidAmount);
                }
              } else if (j.method == "cash") {
                var exactCash =
                  parseFloat(i.balanceAmount) <= 0
                    ? parseFloat(j.paidAmount) + parseFloat(i.balanceAmount)
                    : parseFloat(j.paidAmount);
                if (obj.hasOwnProperty(j.method)) {
                  obj[j.method] = obj[j.method] + exactCash;
                } else {
                  obj[j.method] = exactCash;
                }
              }
            });
          }
        }
      }
    });

    billList.forEach((k) => {
      const fullyReturned = k.items.every((i) => i.fullyReturned);
      if (k.creditHistory && !fullyReturned) {
        if (k.creditHistory.length > 0) {
          k.creditHistory?.map((history) => {
            if (Array.isArray(history.paymentMethod)) {
              history.paymentMethod.map((data) => {
                if (obj.hasOwnProperty(data.method)) {
                  obj[data.method] =
                    obj[data.method] + parseFloat(data.amountPaid);
                } else {
                  obj[data.method] = parseFloat(data.amountPaid);
                }
              });
            } else {
            }
          });
        }
      }
    });
    billList.forEach((data) => {
      const fullyReturned = data.items.every((i) => i.fullyReturned);
      if (data.billReturn && !fullyReturned) {
        data.billReturn.map((value) => {
          if (obj.hasOwnProperty(value.repayMethod)) {
            obj[value.repayMethod] =
              obj[value.repayMethod] - parseFloat(value.repayAmount);
          } else {
            obj[value.repayMethod] = -parseFloat(value.repayAmount);
          }
        });
      }
    });
    console.log("obj after credit", obj);
    return obj;
  };

  const gettingOldPaymentData = () => {
    var obj = {};
    billList.forEach((data) => {
      var paymentMethod = data.paymentMethod
        ? data.paymentMethod
        : data.otherDetails?.paymentMethod;
      if (!Array.isArray(paymentMethod)) {
        if (obj.hasOwnProperty(paymentMethod)) {
          obj[paymentMethod] = obj[paymentMethod] + parseFloat(data.amountPaid);
        } else {
          obj[paymentMethod] = parseFloat(data.amountPaid);
        }
      }
    });
    console.log("obeyjj", obj);
    return obj;
  };

  const paymentAnalysis = useMemo(() => {
    let result = {};
    var totalSales = 0;
    var cancelledBills = 0;
    var repaidAmount = 0;
    var creditTotal = 0;

    let discountFlat = 0;
    let discountPer = 0;
    let temprepaidflat = 0;
    let temprepaiddis = 0;
    let temprepaidnormal = 0;
    let fullyReturnedTotal = 0;

    billList.map((data) => {
      totalSales += parseFloat(data.amountPaid);
    });

    billList.map((data) => {
      if (data.billCancelled) {
        cancelledBills += parseFloat(data.amountPaid);
      }
    });

    billList.map((data) => {
      if (data.billReturn) {
        const isPartialBill = data.billReturn.some((i) => i.partial === true);
        if (!isPartialBill) {
          if (data.otherDetails) {
            if (
              data.otherDetails.discountType &&
              data.otherDetails.discount !== 0
            ) {
              if (
                data.otherDetails.discountType === "flat" &&
                data.otherDetails.discount !== 0
              ) {
                if (data.otherDetails.discount) {
                  data.items.forEach((value) => {
                    if (value.returned) {
                      temprepaidflat += parseFloat(value.itemTotal);
                    }
                  });
                  discountFlat += parseFloat(data.otherDetails.discount);
                }
              } else if (
                data.otherDetails.discountType === "percentage" &&
                data.otherDetails.discount !== 0
              ) {
                if (data.otherDetails.discount) {
                  let temprepaiddis1 = 0;
                  data.items.forEach((value) => {
                    if (value.returned) {
                      // temprepaiddis1 = parseFloat(value.itemTotal);
                      temprepaiddis1 += parseFloat(value.itemTotal);
                      temprepaiddis += parseFloat(value.itemTotal);
                    }
                  });
                  discountPer +=
                    (parseFloat(temprepaiddis1) *
                      parseFloat(data.otherDetails.discount)) /
                    100;
                }
              }
            } else {
              data.items.forEach((value) => {
                if (value.returned) {
                  temprepaidnormal += parseFloat(value.itemTotal);
                }
              });
            }

            var totalflatreturn = temprepaidflat - discountFlat;
            var totaldicreturn = temprepaiddis - discountPer;
          } else {
            if (data.discountType && data.discount !== 0) {
              if (data.discountType === "flat" && data.discount !== 0) {
                if (data.discount) {
                  data.items.forEach((value) => {
                    if (value.returned) {
                      temprepaidflat += parseFloat(value.itemTotal);
                    }
                  });
                  discountFlat += parseFloat(data.discount);
                }
              } else if (
                data.discountType === "percentage" &&
                data.discount !== 0
              ) {
                if (data.discount) {
                  let temprepaiddis1 = 0;
                  data.items.forEach((value) => {
                    if (value.returned) {
                      // temprepaiddis1 = parseFloat(value.itemTotal);
                      temprepaiddis1 += parseFloat(value.itemTotal);
                      temprepaiddis += parseFloat(value.itemTotal);
                    }
                  });
                  discountPer +=
                    (parseFloat(temprepaiddis1) * parseFloat(data.discount)) /
                    100;
                }
              }
            } else {
              data.items.forEach((value) => {
                if (value.returned) {
                  temprepaidnormal += parseFloat(value.itemTotal);
                }
              });
            }

            var totalflatreturn = temprepaidflat - discountFlat;
            var totaldicreturn = temprepaiddis - discountPer;
          }

          //repaidAmount = temprepaidnormal + totalflatreturn + totaldicreturn;
        } else if (isPartialBill) {
          const fullyReturned = data.items.every((i) => i.fullyReturned);
          if (!fullyReturned) {
            data.billReturn.forEach((value) => {
              repaidAmount =
                parseFloat(repaidAmount) + parseFloat(value.repayAmount);
              if (value.repayMethod === "clearCredits") {
                const creditHistory = data.creditHistory?.find((i) => {
                  return (
                    i.updatedTime ===
                    moment(value.returnedData, "YYYY-MM-DD hh:mm A").format(
                      "hh:mm a"
                    )
                  );
                });

                if (creditHistory) {
                  repaidAmount =
                    parseFloat(repaidAmount) +
                    parseFloat(creditHistory.amountPaid);
                }
              }
            });
          } else if (fullyReturned) {
            fullyReturnedTotal += parseFloat(data.amountPaid);
          }
        }
      }
    });

    totalSales =
      totalSales - (repaidAmount + cancelledBills) - fullyReturnedTotal;
    setTotalSale(totalSales);
    setTotalSalesValue(totalSales);
    setTotalSalesReturn(repaidAmount + cancelledBills + fullyReturnedTotal);

    var newData = newPaymentMethodData();

    var cashTotal = parseFloat(newData.cash) ? parseFloat(newData.cash) : 0;
    var cardTotal = parseFloat(newData.card) ? parseFloat(newData.card) : 0;
    var upiTotal = parseFloat(newData.upi) ? parseFloat(newData.upi) : 0;

    var oldData = gettingOldPaymentData();
    var oldCash = parseFloat(oldData.cash) ? parseFloat(oldData.cash) : 0;
    var oldCard = parseFloat(oldData.card) ? parseFloat(oldData.card) : 0;
    var oldUpi = parseFloat(oldData.upi) ? parseFloat(oldData.upi) : 0;

    setCashTotal(cashTotal + oldCash);
    setUpiTotal(upiTotal + oldUpi);
    setCardTotal(cardTotal + oldCard);
    billList.map((data) => {
      if (data.balanceAmount > 0) {
        creditTotal += parseFloat(data.balanceAmount);
      }
    });
    setCreditTotal(creditTotal);
    //   var creditTotal = 0;
    //   var cancelledBillArr = [];
    //   if (billList.length > 0) {
    //     const output = groupBy(billList, function (obj) {
    //       if (!obj.billCancelled) {
    //         creditTotal =
    //           parseFloat(creditTotal) +
    //           (parseFloat(obj.balanceAmount) > 0
    //             ? parseFloat(obj.balanceAmount)
    //             : 0.0);
    //         if (obj?.paymentMethod) {
    //           return obj.paymentMethod;
    //         } else {
    //           return obj.otherDetails.paymentMethod;
    //         }
    //       } else {
    //         cancelledBillArr.push(obj);
    //       }
    //     });
    //     const cardArray = output?.card || [];
    //     const cashArray = output?.cash || [];
    //     const upiArray = output?.upi || [];

    //     const cardTotal = sumBy(cardArray, function (o) {
    //       let creditHistory = 0;
    //       if (o.creditHistory?.length > 0) {
    //         o.creditHistory?.forEach(
    //           (i) => creditHistory + parseFloat(i.amountPaid)
    //         );
    //       } else if (o.balanceAmount > 0) {
    //         creditHistory = o.balanceAmount;
    //       }
    //       return parseFloat(o.amountPaid) - creditHistory;
    //     });

    //     const cashTotal = sumBy(cashArray, function (o) {
    //       let creditHistory = 0;
    //       if (o.creditHistory?.length > 0) {
    //         const creditHistoryResult = 0;
    //         o.creditHistory?.forEach(
    //           (i) => creditHistoryResult + parseFloat(i.amountPaid)
    //         );
    //         creditHistory = creditHistoryResult;
    //         // console.log("creditHistory", o.creditHistory, creditHistory);
    //       } else if (o.balanceAmount > 0) creditHistory = o.balanceAmount;

    //       return parseFloat(o.amountPaid) - creditHistory;
    //     });
    //     const upiTotal = sumBy(upiArray, function (o) {
    //       let creditHistory = 0;
    //       if (o.creditHistory?.length > 0) {
    //         o.creditHistory?.forEach(
    //           (i) => creditHistory + parseFloat(i.amountPaid)
    //         );
    //       } else if (o.balanceAmount > 0) creditHistory = o.balanceAmount;
    //       return parseFloat(o.amountPaid) - creditHistory;
    //     });

    //     const creditClearedCash = creditClearedAmount(billList, "cash");
    //     const creditClearedCard = creditClearedAmount(billList, "card");
    //     const creditClearedUpi = creditClearedAmount(billList, "upi");

    //     var newData = newPaymentMethodData();

    //     var newUpiData = newData.upi ? parseFloat(newData.upi) : 0;
    //     var newCardData = newData.card ? parseFloat(newData.card) : 0;
    //     var newCashData = newData.cash ? parseFloat(newData.cash) : 0;

    //     const total_Sales =
    //       cardTotal +
    //       newCardData +
    //       creditClearedCard +
    //       cashTotal +
    //       newCashData +
    //       creditClearedCash +
    //       upiTotal +
    //       newUpiData +
    //       creditClearedUpi +
    //       creditTotal;

    //     console.log(
    //       "DOTAL",
    //       cardTotal,
    //       newCardData,
    //       creditClearedCard,
    //       cashTotal,
    //       newCashData,
    //       creditClearedCash,
    //       upiTotal,
    //       newUpiData,
    //       creditClearedUpi,
    //       creditTotal
    //     );
    //     result = {
    //       card: cardTotal + creditClearedCard + newCardData,
    //       cash: cashTotal + creditClearedCash + newCashData,
    //       upi: upiTotal + creditClearedUpi + newUpiData,
    //       credit: creditTotal,
    //     };
    //     console.log(
    //       "totalSale",
    //       total_Sales,
    //       cardTotal + creditClearedCard,
    //       cashTotal + creditClearedCash,
    //       upiTotal + creditClearedUpi,
    //       creditTotal
    //     );
    //     const cancelledBillTotal = sumBy(cancelledBillArr, (data) =>
    //       parseFloat(data.amountPaid)
    //     );
    //     let repaidAmount = 0;
    //     billList.map((data) => {
    //       if (data.billReturn) {
    //         data.items.map((value) => {
    //           if (value.returned) {
    //             console.log("Came Inside");
    //             repaidAmount += parseFloat(value.itemTotal);
    //           }
    //         });
    //       }
    //     });
    //     setTotalSale(total_Sales);
    //     setTotalSalesReturn(cancelledBillTotal + repaidAmount);
    //   } else {
    //     setTotalSale(0);
    //     setTotalSalesReturn(0);
    //   }

    return result;
  }, [billList]);

  const checkReturnedItems = (data) => {
    if (data.billReturn) {
      if (data.billReturn.length > 0) {
        const isFullyReturned = data.items.every(
          (i) => i.fullyReturned === true
        );
        return isFullyReturned ? (
          <Tag
            color="purple"
            style={{
              width: 120,
              textAlign: "center",
            }}
          >
            Fully Returned
          </Tag>
        ) : (
          <Tag
            color="magenta"
            style={{
              width: 120,
              textAlign: "center",
            }}
          >
            Partially Returned
          </Tag>
        );
        // }
      }
    }
  };
  const fetchCategoryFromProduct = (prodArr) => {
    let categoryArr = [];
    if (prodArr.length > 0) {
      prodArr.map((data) => {
        let fnd = categoryArr.findIndex((i) => i === data.category);
        if (fnd === -1) {
          categoryArr.push(data.category);
        }
      });
    }
    setProductDetails(prodArr);
    setProducts(prodArr);
    setCategoryArray(categoryArr);
  };

  const getTotalCount = (data) => {
    let result = sumBy(data, (o) => {
      return parseFloat(o.count);
    });
    return result;
  };

  const getTaxMaster = (taxId) => {
    return taxList?.find((tax) => tax.taxId === taxId) || {};
  };

  useMemo(() => {
    let result = [];
    let data = [];
    const bills_ = billList.sort((a, b) => {
      return new Date(a.billingDate) - new Date(b.billingDate);
    });
    if (bills_.length > 0) {
      bills_.forEach((bill) => {
        if (!bill.billCancelled) {
          bill.items?.forEach((item) => {
            if (!item.returned) {
              data.push(item);
            }
          });
        }
      });
      console.log("dataCHECKING", data);
      const output = groupBy(data, "productId");
      const objToarray = values(output);
      result = objToarray.map((objs, key) => {
        const lastdata = objs[objs.length - 1];
        const taxMaster = getTaxMaster(objs[0]?.taxId);
        return {
          productName: objs[0]?.productName,
          count: getTotalCount(objs),
          category: objs[0].category,
          subCategory: objs[0].subCategory,
          purchasePrice: objs[0].purchasePrice,
          productMrp: objs[0].productMrp,
          productPrice: lastdata.productPrice,
          productEANCode: objs[0].productEANCode,
          productHsnCode: objs[0].productHsnCode,
          productCode: objs[0].productCode,
          taxId: objs[0].taxId ? objs[0].taxId : undefined,
          taxMaster: objs[0].taxId ? getTaxMaster(objs[0].taxId) : undefined,
          productTax:
            objs[0]?.taxId && Object.keys(taxMaster)?.length !== 0
              ? `${taxMaster?.taxName} => ${
                  taxMaster?.gst ? `GST-${taxMaster?.gst}% ` : ""
                }${taxMaster?.igst ? `IGST-${taxMaster?.igst}% ` : ""}${
                  taxMaster?.cess ? `CESS-${taxMaster?.cess}% ` : ""
                }${
                  taxMaster?.additionalcess
                    ? `Add.cess-${taxMaster?.additionalcess}%`
                    : ""
                } `
              : objs[0]?.productTax
              ? `${objs[0]?.productTax}%`
              : objs[0]?.productTaxType
              ? `${objs[0]?.productTaxType}%`
              : "",
          taxIncExc: objs[0].taxIncExc,
          productBrand: objs[0].productBrand,
          unitOfMeasurment: objs[0].unitOfMeasurment,
          totalAmount: sumBy(objs, function (o) {
            return parseFloat(o.itemTotal || 0);
          }),
        };
      });
    }
    fetchCategoryFromProduct(result);
    const sortRes = sortArray(result);
    setProductDetails(sortRes);
    return sortRes;
  }, [billList]);

  useEffect(() => {
    if (shopDetails.userType === "Employee") {
      setSelectedEmployee(shopDetails.empId);
    }
  }, [shopDetails.userType]);

  useEffect(() => {
    if (billList.length > 0) {
      let billsCancelled = billList.filter((data) => {
        if (data.billCancelled || data.billReturn) {
          return data;
        }
      });

      setCancelledBill(billsCancelled);
    } else {
      setCancelledBill([]);
    }
  }, [billList]);

  useEffect(() => {
    let tempProd = products;
    if (tempProd.length > 0) {
      if (category === "") {
        setProductDetails(tempProd);
        return;
      }
      tempProd = tempProd.filter((data) => data.category === category);
      tempProd = sortArray(tempProd);
      setProductDetails(tempProd);
    }
  }, [category]);

  useEffect(() => {
    const fetchTaxsList = async (shopId) => {
      setTaxLoader(true);
      var res = await fetch(`${config.newApiGateway}/taxMaster/taxMaster`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          action: "fetchTaxmaster",
          shopId: shopId,
        }),
      });
      setTaxLoader(false);
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      setTaxList(res.data);
    };
    if (shopId) {
      fetchTaxsList(shopId);
    }
  }, [shopId]);

  const processCustomerBillData = () => {
    let tempArr = [];
    billList.map((data) => {
      if (!data.billCancelled) {
        let fnd = tempArr.findIndex(
          (i) => i.customerPhoneNumber === data.customerPhoneNumber
        );
        if (fnd === -1) {
          data.numberOfBills = 1;
          data.averagePurchase = data.amountPaid;
          data.totalBillAmount = data.amountPaid;
          tempArr.push(data);
        } else {
          tempArr[fnd].totalBillAmount = (
            parseFloat(tempArr[fnd].totalBillAmount) +
            parseFloat(data.amountPaid)
          ).toFixed(2);
          tempArr[fnd].numberOfBills += 1;
          tempArr[fnd].averagePurchase = (
            parseInt(tempArr[fnd].totalBillAmount) / tempArr[fnd].numberOfBills
          ).toFixed(2);
        }
      }
    });
    setBillData(tempArr);
  };

  useEffect(() => {
    if (billList.length > 0) {
      processCustomerBillData();
    } else {
      setBillData([]);
    }
  }, [billList]);

  const getInvoiceDetails = (mobileNumber) => {
    let billTemp = billList;
    let tempArr = billTemp.filter(
      (data) => data.customerPhoneNumber === mobileNumber
    );
    let tempBillArray = [];
    tempArr.map((data) => {
      tempBillArray.push({
        billId: data.billId,
        billingDate: data.billingDate,
        invoiceNumber: data.invoicePrefix
          ? data.invoicePrefix + data.invoiceNumber.toString()
          : data.invoiceNumber.toString(),
        customerName: data.customerName,
        customerPhoneNumber: data.customerPhoneNumber,
        amountPaid: data.amountPaid,
        billCancelled: data.billCancelled ? (
          <div className="fullyReturnedTag">Fully Returned</div>
        ) : data.billReturn ? (
          <div>{checkReturnedItems(data)}</div>
        ) : (
          <div className="activeTag">Active</div>
        ),
      });
    });
    setInvoiceDetails(tempBillArray);
    setInvoiceModal(true);
  };

  console.log("selectedEmployee", selectedEmployee);
  // console.log("billList", billList);

  const getCustomerReport = async () => {
    setCsvLoader(true);
    // setViewTrigger(true);
    const fromDate =
      (dates && dates[0].format("YYYY-MM-DD")) ||
      (value && value[0].format("YYYY-MM-DD"));
    const toDate =
      (dates && dates[1].format("YYYY-MM-DD")) ||
      (value && value[1].format("YYYY-MM-DD"));
    try {
      var res = await fetch(
        `${config.newApiGateway}/customer/generateCustomerBillReport`,
        {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            shopId: shopId,
            from: fromDate,
            to: toDate,
            employeeId: selectedEmployee ? selectedEmployee : "",
          }),
        }
      );
      res = await res.json();
      if (res.code === "ERROR") {
        setCsvLoader(false);
        alert(res.message);
        return;
      }
      window.open(res.data);
      setCsvLoader(false);
    } catch (err) {
      setCsvLoader(false);
      alert("Error while generating report. Please try again.");
    }
  };

  function PatchedPagination(props) {
    const {
      ActionsComponent,
      onChangePage,
      onChangeRowsPerPage,
      ...tablePaginationProps
    } = props;
    return (
      <TablePagination
        {...tablePaginationProps}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        ActionsComponent={(subprops) => {
          const { onPageChange, ...actionsComponentProps } = subprops;
          return (
            <ActionsComponent
              {...actionsComponentProps}
              onChangePage={onPageChange}
            />
          );
        }}
      />
    );
  }

  const [dates, setDates] = useState([dayjs(), dayjs()]);
  const [value, setValue] = useState([dayjs(), dayjs()]);
  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate =
      (dates[0] && current.diff(dates[0], "days") > 30) || current > dayjs();
    const tooEarly = dates[1] && dates[1].diff(current, "days") > 30;
    return !!tooEarly || !!tooLate;
  };
  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const salesReportColumns = [
    {
      title: "Customer Name",
      dataIndex: "customerName",
    },
    {
      title: "Mobile Number",
      render: (rowData) => {
        return <span>{rowData.customerPhoneNumber}</span>;
      },
    },
    {
      title: "Number of Bills",
      dataIndex: "numberOfBills",
    },
    {
      title: `Total Bill Amount(${country.CurrencySymbol})`,
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.totalBillAmount)}</div>;
      },
    },
    {
      title: `Average Purchase(${country.CurrencySymbol})`,
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.averagePurchase)}</div>;
      },
    },
    {
      title: "View Details",
      render: (data) => {
        return (
          <div className="ViewDetailsBtn">
            <AntdButton
              type="primary"
              ghost
              onClick={() => getInvoiceDetails(data.customerPhoneNumber)}
            >
              View Details
            </AntdButton>
          </div>
        );
      },
    },
  ];

  const topSellingColumn = [
    {
      title: "Item Name",
      cellStyle: {
        whiteSpace: "nowrap",
      },
      render: (rowData) => {
        return (
          <div>
            {rowData.productName}{" "}
            {rowData?.unitOfMeasurment && rowData?.unitOfMeasurment}
          </div>
        );
      },
    },
    {
      title: "Item Brand",
      dataIndex: "productBrand",
      cellStyle: {
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Quantity",
      dataIndex: "count",
      cellStyle: {
        whiteSpace: "nowrap",
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      cellStyle: {
        whiteSpace: "nowrap",
      },
    },
    {
      title: `Purchase Price(${country.CurrencySymbol})`,
      dataIndex: "purchasePrice",
      cellStyle: {
        whiteSpace: "nowrap",
      },
      render: (purchasePrice) => {
        return <div>{currencyFormatter(purchasePrice)}</div>;
      },
    },
    {
      title: `MRP(${country.CurrencySymbol})`,
      field: "productMrp",
      cellStyle: {
        whiteSpace: "nowrap",
      },
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.productMrp)}</div>;
      },
    },
    {
      title: `Selling Price(${country.CurrencySymbol})`,
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.productPrice)}</div>;
      },
    },
    {
      title: "EAN Code",
      dataIndex: "productEANCode",
    },
    {
      title: "HSN Code",
      dataIndex: "productHsnCode",
    },
    {
      title: "Product Code",
      dataIndex: "productCode",
    },
    {
      title: "Product Tax",
      dataIndex: "productTax",
      cellStyle: {
        whiteSpace: "nowrap",
      },
      // render: (data) => {
      //   return (
      //     <>
      //       {data.taxId &&
      //       Object.keys(data.taxMaster).length !== 0 ? (
      //         <>
      //           {" "}
      //           <div>{data.taxMaster?.taxName}</div>
      //           {"("}
      //           {data.taxMaster?.gst && (
      //             <span>{`GST ${data.taxMaster?.gst}%`} </span>
      //           )}
      //           {data.taxMaster?.igst && (
      //             <span>{`, IGST ${data.taxMaster?.igst}%`}</span>
      //           )}
      //           {data.taxMaster?.cess && (
      //             <span>{`, Cess ${data.taxMaster?.cess}%`}</span>
      //           )}
      //           {data.taxMaster?.additionalcess && (
      //             <span>{`, Addi.cess ${data.taxMaster?.additionalcess}%`}</span>
      //           )}
      //           {")"}
      //         </>
      //       ) : (
      //         <p>
      //           {data.productTax ? `${data.productTax}%` : "0%"}{" "}
      //           {data.productTaxType
      //             ? `(${data.productTaxType})`
      //             : ""}
      //         </p>
      //       )}
      //     </>
      //   );
      // },
    },
    {
      title: "Inclusice/Exclusive",
      field: "taxIncExc",
      render: (data) => {
        return (
          <div>
            {data?.taxIncExc ? (
              <>
                {data.taxIncExc === "inclusive" && (
                  <>
                    <span>Inclusive</span>
                  </>
                )}
                {data.taxIncExc === "exclusive" && (
                  <>
                    <span>Exclusive</span>
                  </>
                )}
              </>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      title: `Total Sales(${country.CurrencySymbol})`,
      sorter: (a, b) => parseFloat(b.totalAmount) - parseFloat(a.totalAmount),
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.totalAmount)}</div>;
      },
    },
  ];
  const returnTableColumns = [
    {
      title: "Billling Date",
      render: (rowData) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div>{rowData.billingDate}</div>
            <div style={{ color: "red" }}>{checkReturnedItems(rowData)}</div>
          </div>
        );
      },
      defaultSort: "desc",
    },
    {
      title: "Invoice Number",

      render: (rowData) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div>
              {rowData?.invoicePrefix}
              {rowData.invoiceNumber}
            </div>
          </div>
        );
      },
      defaultSort: "desc",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
    },
    {
      title: "Mobile Number",
      render: (rowData) => {
        return <span>{rowData.customerPhoneNumber}</span>;
      },
    },
    {
      title: `Total Bill Amount(${country.CurrencySymbol})`,
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.amountPaid)}</div>;
      },
    },
  ];

  const smsTableColumns = [
    {
      title: "Billling Date",
      render: (rowData) => {
        return (
          <div>
            <div>{rowData.billingDate}</div>
            <div style={{ color: "red" }}>{checkReturnedItems(rowData)}</div>
          </div>
        );
      },
      defaultSort: "desc",
    },
    {
      title: "Invoice Number",

      render: (rowData) => {
        return (
          <div>
            <div>
              {rowData?.invoicePrefix}
              {rowData.invoiceNumber}
            </div>
          </div>
        );
      },
      defaultSort: "desc",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
    },
    {
      title: "Mobile Number",
      render: (rowData) => {
        return <span>{rowData.customerPhoneNumber}</span>;
      },
    },
  ];

  const exportHeadTopSelling = [
    "Item Name",
    "Item Brand",
    "Quantity",
    "Category",
    "Purchase Price",
    "MRP",
    "Selling Price",
    "EAN Code",
    "HSN Code",
    "Product Code",
    "Product Tax",
    "Inclusice/Exclusive",
    "Total Sales",
  ];

  const exportValesTopSelling = [
    "productName",
    "productBrand",
    "inventoryCount",
    "category",
    "purchasePrice",
    "productMrp",
    "productPrice",
    "productEANCode",
    "productHsnCode",
    "productCode",
    "productTax",
    "taxIncExc",
    "totalAmount",
  ];

  const exportHeadSalesReport = [
    "Customer Name",
    "Mobile Number",
    "Number Of Bills",
    "Total Bill Amount",
    "Average Purchase",
  ];

  const exportValesSalesReport = [
    "customerName",
    "customerPhoneNumber",
    "numberOfBills",
    "totalBillAmount",
    "averagePurchase",
  ];

  const exportHeadSMSReports = [
    "Billing Date",
    "Invoice Number",
    "Customer Name",
    "Mobile Number",
  ];

  const exportValuesSMSReports = [
    "billingDate",
    {
      field: "invoiceNumber",
      render: (rowData) => {
        return rowData?.invoicePrefix + rowData?.invoiceNumber;
      },
    },
    "customerName",
    "customerPhoneNumber",
  ];

  const smsReportsList = useMemo(() => {
    return billList.filter((i) => i.isSms);
  }, [billList]);

  return (
    <>
      <div>
        {taxLoader && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <Loader size={56} />
          </Box>
        )}
        {/* <Card id="report-card">
          <div
            style={{
              width: 400,
              display: "inline-block",
            }}
          >
            <RangePicker
              value={dates || value}
              style={{
                width: "400px",
              }}
              size="medium"
              disabledDate={disabledDate}
              onCalendarChange={(val) => setDates(val)}
              onChange={(val) => setValue(val)}
              onOpenChange={onOpenChange}
            />
          </div>
          <div
            style={{
              display: "inline-block",
            }}
          >
            <Select
              style={{
                width: 150,
              }}
              onChange={(value) => {
                if (value === "All Employees") {
                  setSelectedEmployee("");
                } else {
                  setSelectedEmployee(value);
                }
              }}
              value={selectedEmployee}
              allowClear
              disabled={shopDetails.userType === "Employee"}
              placeholder="All Employees"
            >
              {employeeArr.map((data) => (
                <Select.Option value={data.userId}>
                  {data.userName}{" "}
                </Select.Option>
              ))}
            </Select>
          </div>
          <AntdButton
            onClick={() => {
              setViewTrigger(true);
            }}
            type="primary"
            ghost
            size="medium"
            disabled={fetchLoading || isLoading}
          >
            View
          </AntdButton>
          <AntdButton
            type="primary"
            size="medium"
            disabled={csvLoader}
            onClick={getCustomerReport}
            style={{
              paddingLeft: 8,
              paddingRight: 8,
            }}
          >
            {csvLoader ? (
              <>
                Generating...{" "}
                <Spinner variant="danger" animation="border" size="sm" />
              </>
            ) : (
              <FiDownload
                size={20}
                style={{
                  margin: 0,
                }}
              />
            )}
          </AntdButton>
        </Card> */}
        {!taxLoader && (
          <div>
            <div>
              <div className="reportsHeadingFilters">
                {/* <div
                  style={{
                    width: 400,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <span> From </span>
                    <span
                      style={{
                        margin: "0 auto",
                      }}
                    >
                      To{" "}
                    </span>
                  </div>
                  <RangePicker
                    value={dates || value}
                    style={{
                      width: "400px",
                      border: "2px solid rgb(118 118 118)",
                      outline: "transparent",
                      height: 38,
                      borderRadius: 6,
                    }}
                    size="medium"
                    disabledDate={disabledDate}
                    onCalendarChange={(val) => setDates(val)}
                    onChange={(val) => setValue(val)}
                    onOpenChange={onOpenChange}
                    onBlur={() => console.log("blur has been triggered")}
                  />
                </div>
                {employeeArr.length > 0 ? (
                  <div>
                    <div>Users</div>
                    <select
                      onChange={(e) => {
                        if (e.target.value == "All Employees") {
                          setSelectedEmployee("");
                        } else {
                          var d = employeeArr.filter((data) => {
                            return data.userName == e.target.value;
                          });
                          setSelectedEmployee(d[0].userId);
                          console.log("DHANUSH", d);
                        }
                      }}
                      className="getEmployeeReport"
                    >
                      <option>All Employees</option>
                      {employeeArr.map((data) => (
                        <option>{data.userName}</option>
                      ))}
                    </select>
                  </div>
                ) : (
                  <select className="getEmployeeReport">
                    <option>All Employee</option>
                  </select>
                )}
                <div>
                  <Button
                    variant="outline-danger"
                    style={{
                      height: 34,
                    }}
                    size="sm"
                    onClick={() => {
                      setViewTrigger(true);
                    }}
                    disabled={fetchLoading || isLoading}
                  >
                    View
                  </Button>
                </div>
                <div>
                  <div
                    // variant="outline-danger"
                    disabled={csvLoader}
                    size="sm"
                    onClick={getCustomerReport}
                    className="downloadReportButton"
                  >
                    {csvLoader ? (
                      <>
                        Generating...{" "}
                        <Spinner
                          variant="danger"
                          animation="border"
                          size="sm"
                        />
                      </>
                    ) : (
                      <FiDownload />
                    )}
                  </div>
                </div> */}
              </div>
              {isLoading && (
                <Box
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "60%",
                    transform: "translate(-50%,-50%)",
                    zIndex: 10,
                  }}
                >
                  <Loader size={75} />
                </Box>
              )}
              {!isLoading && (
                <Row className="rowgap-vbox" gutter={[24, 0]}>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
                    <AnalyticsCard
                      label={currencyFormatter(totalSale)}
                      value={"Total Sales"}
                      icon={<TotalSalesIcon size={35} color={"#fff"} />}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
                    <AnalyticsCard
                      value={"Average Value Per Sale"}
                      label={currencyFormatter(
                        totalSale /
                          billList.filter((i) => {
                            const fullyReturned = i.items.every(
                              (i) => i.fullyReturned
                            );
                            return fullyReturned === false;
                          }).length
                      )}
                      icon={<AverageSaleIcon size={30} color={"#fff"} />}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
                    <AnalyticsCard
                      value={"Total Sales Return"}
                      label={currencyFormatter(totalSalesReturn)}
                      icon={<SalesReturnIcon size={30} color={"#fff"} />}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
                    <AnalyticsCard
                      value={"Card payment"}
                      label={currencyFormatter(cardTotal)}
                      icon={<BsCreditCard color="#fff" size={30} />}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
                    <AnalyticsCard
                      value={"Cash collected"}
                      label={currencyFormatter(cashTotal)}
                      icon={<BsCash color="#fff" size={30} />}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
                    <AnalyticsCard
                      value={"UPI payment"}
                      label={currencyFormatter(upiTotal)}
                      icon={
                        <UpiIcon
                          style={{
                            transform: "scale(0.4) translate(-29px, -7px)",
                          }}
                          size={35}
                          color={"#fff"}
                        />
                      }
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
                    <AnalyticsCard
                      value={"Credit amount"}
                      label={currencyFormatter(creditTotal)}
                      icon={<CreditIcon size={35} color={"#fff"} />}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8} className="mb-24">
                    <AnalyticsCard
                      value={"Total Expenses"}
                      label={currencyFormatter(totalExpenses)}
                      icon={
                        <FontAwesomeIcon
                          icon={faCashRegister}
                          color="#fff"
                          size="2x"
                        />
                      }
                    />
                  </Col>
                  {/* {shopDetails.loyaltyPackage === "yes" && (
                    <>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={8}
                        xl={8}
                        className="mb-24"
                      >
                        <AnalyticsCard
                          value={"Recurring Customers"}
                          label={recurringCustomers}
                          icon={
                            <RecurringCustomersIcon color="#fff" size={30} />
                          }
                        />
                      </Col>
                      <Col
                        xs={24}
                        sm={24}
                        md={12}
                        lg={8}
                        xl={8}
                        className="mb-24"
                      >
                        <AnalyticsCard
                          value={"New Customer"}
                          label={newCustomer}
                          icon={<NewCustomerIcon color="#fff" size={30} />}
                        />
                      </Col>
                    </>
                  )} */}
                </Row>
              )}
              {!isLoading && (
                <>
                  {/* <div className="reports-overview">
                    <div className="card-style">
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                        }}
                      >
                        <h5>Total Sales</h5>
                        {fetchLoading && <CircularProgress size={20} />}
                      </div>

                      <h2>
                        {currencyFormatter(totalSale)}
                        <CountUp
                          className="account-balance"
                          start={0}
                          end={totalSale}
                          duration={2.75}
                          separator=" "
                          decimals={4}
                          decimal=","
                          prefix="Rs "
                          suffix=" left"
                          onEnd={() => console.log("Ended! 👏")}
                          onStart={() => console.log("Started! 💨")}
                        />
                      </h2>
                    </div>
                    <div className="card-style" style={{ marginLeft: "20px" }}>
                      <h5>Average Value Per Sale</h5>
                      <h2>
                        {billList.length === 0
                          ? currencyFormatter(0)
                          : currencyFormatter(
                              parseFloat(totalSale) / billList.length
                            )}
                      </h2>
                    </div>
                    <div className="card-style" style={{ marginLeft: "20px" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                        }}
                      >
                        <h5>Total Sales Return</h5>
                        {fetchLoading && <CircularProgress size={20} />}
                      </div>
                      <h2>{currencyFormatter(totalSalesReturn)}</h2>
                    </div>
                  </div> */}
                  {/* <div
                    className="reports-overview"
                    style={{
                      marginTop: "20px",
                      width: "100%",
                    }}
                  >
                    <div className="card-style">
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                        }}
                      >
                        <h5>Card payment</h5>
                        {fetchLoading && <CircularProgress size={20} />}
                      </div>
                      <h2>{currencyFormatter(parseFloat(cardTotal) || 0)}</h2>
                    </div>
                    <div className="card-style" style={{ marginLeft: "20px" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                        }}
                      >
                        <h5>Cash collected</h5>
                        {fetchLoading && <CircularProgress size={20} />}
                      </div>
                      <h2>{currencyFormatter(parseFloat(cashTotal))}</h2>
                    </div>
                    <div className="card-style" style={{ marginLeft: "20px" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                        }}
                      >
                        <h5>UPI payment</h5>
                        {fetchLoading && <CircularProgress size={20} />}
                      </div>
                      <h2>{currencyFormatter(parseFloat(upiTotal))}</h2>
                    </div>
                    <div className="card-style" style={{ marginLeft: "20px" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                        }}
                      >
                        <h5>Credit amount</h5>
                        {fetchLoading && <CircularProgress size={20} />}
                      </div>
                      <h2>{currencyFormatter(creditTotal)}</h2>
                    </div>
                  </div>
                  <div id="tableSearchSelect">
                    <MaterialTable
                      style={{ marginTop: "20px" }}
                      columns={[
                        {
                          title: "Customer Name",
                          field: "customerName",
                        },
                        {
                          title: "Mobile Number",
                          field: "customerPhoneNumber",
                          render: (rowData) => {
                            return <span>{rowData.customerPhoneNumber}</span>;
                          },
                        },
                        {
                          title: "Number of Bills",
                          field: "numberOfBills",
                        },
                        {
                          title: `Total Bill Amount(${country.CurrencySymbol})`,
                          field: "totalBillAmount",
                          render: (rowData) => {
                            return (
                              <div>
                                {currencyFormatter(rowData.totalBillAmount)}
                              </div>
                            );
                          },
                        },
                        {
                          title: `Average Purchase(${country.CurrencySymbol})`,
                          field: "averagePurchase",
                          render: (rowData) => {
                            return (
                              <div>
                                {currencyFormatter(rowData.averagePurchase)}
                              </div>
                            );
                          },
                        },
                        {
                          title: "View Details",
                          // field: "averagePurchase",
                          render: (data) => {
                            return (
                              <div className="ViewDetailsBtn">
                                <Button
                                  variant="outline-danger"
                                  onClick={() =>
                                    getInvoiceDetails(data.customerPhoneNumber)
                                  }
                                >
                                  View Details
                                </Button>
                              </div>
                            );
                          },
                        },
                      ]}
                      icons={tableIcons}
                      data={billData}
                      title={
                        <div
                          style={{
                            display: "flex",
                            gap: "1rem",
                          }}
                        >
                          <h5>Sales Reports</h5>
                          {fetchLoading && <CircularProgress size={20} />}
                        </div>
                      }
                      components={{
                        Pagination: PatchedPagination,
                      }}
                      options={{
                        search: true,
                        exportButton: {
                          csv: true,
                        },
                        exportAllData: true,
                        columnsButton: true,
                      }}
                    />
                  </div> */}
                  <CustomTable
                    data={billData}
                    columns={salesReportColumns}
                    title={"Sales Report"}
                    loading={isLoading}
                    containerStyle={{
                      marginBottom: 20,
                    }}
                    exportHead={exportHeadSalesReport}
                    exportValue={exportValesSalesReport}
                    excelExport={true}
                  />
                  <CustomTable
                    data={productDetails}
                    columns={topSellingColumn}
                    title={"Top selling products"}
                    loading={isLoading}
                    containerStyle={{
                      marginBottom: 20,
                    }}
                    exportHead={exportHeadTopSelling}
                    exportValue={exportValesTopSelling}
                    excelExport={true}
                  />

                  {/* <MaterialTable
                    style={{ marginTop: "20px" }}
                    isLoading={isLoading}
                    columns={[
                      {
                        title: "Item Name",
                        field: "productName",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                        render: (rowData) => {
                          return (
                            <div>
                              {rowData.productName}{" "}
                              {rowData?.unitOfMeasurment &&
                                rowData?.unitOfMeasurment}
                            </div>
                          );
                        },
                      },
                      {
                        title: "Item Brand",
                        field: "productBrand",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                      },
                      {
                        title: "Quantity",
                        field: "count",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                      },
                      {
                        title: "Category",
                        field: "category",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                      },
                      {
                        title: `Purchase Price(${country.CurrencySymbol})`,
                        field: "purchasePrice",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                        render: (rowData) => {
                          return (
                            <div>
                              {currencyFormatter(rowData.purchasePrice)}
                            </div>
                          );
                        },
                      },
                      {
                        title: `MRP(${country.CurrencySymbol})`,
                        field: "productMrp",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                        render: (rowData) => {
                          return (
                            <div>{currencyFormatter(rowData.productMrp)}</div>
                          );
                        },
                      },
                      {
                        title: `Selling Price(${country.CurrencySymbol})`,
                        field: "productPrice",
                        render: (rowData) => {
                          return (
                            <div>{currencyFormatter(rowData.productPrice)}</div>
                          );
                        },
                      },
                      {
                        title: "EAN Code",
                        field: "productEANCode",
                      },
                      {
                        title: "HSN Code",
                        field: "productHsnCode",
                      },
                      {
                        title: "Product Code",
                        field: "productCode",
                      },
                      {
                        title: "Product Tax",
                        field: "productTax",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                        // render: (data) => {
                        //   return (
                        //     <>
                        //       {data.taxId &&
                        //       Object.keys(data.taxMaster).length !== 0 ? (
                        //         <>
                        //           {" "}
                        //           <div>{data.taxMaster?.taxName}</div>
                        //           {"("}
                        //           {data.taxMaster?.gst && (
                        //             <span>{`GST ${data.taxMaster?.gst}%`} </span>
                        //           )}
                        //           {data.taxMaster?.igst && (
                        //             <span>{`, IGST ${data.taxMaster?.igst}%`}</span>
                        //           )}
                        //           {data.taxMaster?.cess && (
                        //             <span>{`, Cess ${data.taxMaster?.cess}%`}</span>
                        //           )}
                        //           {data.taxMaster?.additionalcess && (
                        //             <span>{`, Addi.cess ${data.taxMaster?.additionalcess}%`}</span>
                        //           )}
                        //           {")"}
                        //         </>
                        //       ) : (
                        //         <p>
                        //           {data.productTax ? `${data.productTax}%` : "0%"}{" "}
                        //           {data.productTaxType
                        //             ? `(${data.productTaxType})`
                        //             : ""}
                        //         </p>
                        //       )}
                        //     </>
                        //   );
                        // },
                      },
                      {
                        title: "Inclusice/Exclusive",
                        field: "taxIncExc",
                        render: (data) => {
                          return (
                            <div>
                              {data?.taxIncExc ? (
                                <>
                                  {data.taxIncExc === "inclusive" && (
                                    <>
                                      <span>Inclusive</span>
                                    </>
                                  )}
                                  {data.taxIncExc === "exclusive" && (
                                    <>
                                      <span>Exclusive</span>
                                    </>
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          );
                        },
                      },
                      {
                        title: `Total Sales(${country.CurrencySymbol})`,
                        field: "totalAmount",
                        render: (rowData) => {
                          return (
                            <div>{currencyFormatter(rowData.totalAmount)}</div>
                          );
                        },
                      },
                    ]}
                    icons={tableIcons}
                    data={productDetails}
                    title={
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                        }}
                      >
                        <h5>Top selling products</h5>
                        {fetchLoading && <CircularProgress size={20} />}
                      </div>
                    }
                    components={{
                      Pagination: PatchedPagination,
                      Toolbar: (props) => (
                        <div>
                          <MTableToolbar {...props} />
                          <div className="customToolBar">
                            <div className="categoryDropdown">
                              <select
                                onChange={(e) => setCategory(e.target.value)}
                                value={category}
                                disabled={
                                  categoryArray.length > 0 ? false : true
                                }
                              >
                                <option value="">Choose a Category</option>
                                {categoryArray.map((data) => (
                                  <option value={data} key={data}>
                                    {data}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      ),
                    }}
                    options={{
                      search: true,
                      exportButton: {
                        csv: true,
                      },
                      exportAllData: true,
                      columnsButton: true,
                    }}
                  /> */}

                  <CustomTable
                    data={cancelledBillList}
                    columns={returnTableColumns}
                    title={"Return Bills"}
                    containerStyle={{
                      marginBottom: 20,
                    }}
                  />
                  <CustomTable
                    data={smsReportsList}
                    columns={smsTableColumns}
                    title={"Sms Report"}
                    containerStyle={{
                      marginBottom: 20,
                    }}
                    excelExport={true}
                    exportHead={exportHeadSMSReports}
                    exportValue={exportValuesSMSReports}
                  />
                </>
              )}
            </div>
            <Modal
              show={invoiceModal}
              onHide={() => setInvoiceModal(false)}
              dialogClassName="custom-invoice-modal"
            >
              <Modal.Body>
                <h2>Customer Details</h2>
                {invoiceDetails[0] !== undefined && (
                  <div>
                    <div>
                      <h5>Name: {invoiceDetails[0].customerName}</h5>
                      <h6>
                        Mobile Number: {invoiceDetails[0].customerPhoneNumber}
                      </h6>
                    </div>
                    <div>
                      <MaterialTable
                        columns={[
                          {
                            title: "Date",
                            field: "billingDate",
                          },
                          {
                            title: "Invoice number",
                            field: "invoiceNumber",
                            defaultSort: "desc",
                          },
                          {
                            title: `Bill Amount(${country.CurrencySymbol})`,
                            field: "amountPaid",
                          },
                          {
                            title: "Status",
                            render: (rowData) => {
                              return (
                                <div>
                                  {rowData.billCancelled ? (
                                    <div>{rowData.billCancelled}</div>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              );
                            },
                          },
                        ]}
                        icons={tableIcons}
                        data={invoiceDetails}
                        title="Invoice details"
                        components={{
                          Pagination: PatchedPagination,
                        }}
                      />
                    </div>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => setInvoiceModal(false)}>Close</Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    </>
  );
};
export default Reports;
